import React, { Component } from 'react';
// @material-ui/core components
import { withStyles } from '@material-ui/core/styles';
// core components
import { Table, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getAllCategory as getAllCategoryList,
  getSuperCategory as getCategoryList,
  addSubCategory,
  upload
} from '../../store/actions/vendor/Vendor';
import CardHeader from '../../components/Card/CardHeader.js';
import CardBody from '../../components/Card/CardBody.js';
import CardFooter from '../../components/Card/CardFooter.js';
import GridItem from '../../components/Grid/GridItem.js';
import GridContainer from '../../components/Grid/GridContainer.js';
import CustomInput from '../../components/CustomInput/CustomInput.js';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

class AddSubCategory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageUploadMessage: '',
      subCategory: {
        name: '',
        icon: '',
        superCategoryId: '',
        categoryId: ''
      }
    };
  }

  componentDidMount() {
    this.props.getAllCategoryList(this.props.match.params.superCategoryId);
    this.props.getCategoryList();
    this.setCategoryAndSuperCategory(
      this.props.match.params.superCategoryId,
      this.props.match.params.categoryId
    );
  }
  onChange = (event) => {
    let subCategory = this.state.subCategory;
    subCategory[event.target.name] = event.target.value;

    this.setState({
      subCategory
    });
  };
  setCategoryAndSuperCategory = (superCategoryId, categoryId) => {
    this.setState((prevState) => ({
      subCategory: {
        ...prevState.subCategory,
        superCategoryId: superCategoryId,
        categoryId: categoryId
      }
    }));
  };
  onChangeSelect = (event) => {
    let subCategory = this.state.subCategory;
    subCategory[event.target.name] = event.target.value;

    this.setState({
      subCategory
    });
  };
  onUpload = (event) => {
    this.setState({
      imageUploadMessage: 'Uploading the file, please wait...'
    });

    let data = new FormData();
    data.append('files', event.target.files[0]);

    // Upload image
    this.props
      .upload(data)
      .then((response) => {
        if (response.status === 201) {
          this.setState({
            imageUploadMessage: 'File uploaded successfully.'
          });
          let subCategory = this.state.subCategory;
          subCategory.icon = `${response.data.uploads[0].path}`;
          this.setState({
            subCategory
          });
        } else {
          this.setState({
            imageUploadMessage: 'Please, try Again'
          });
        }
      })
      .catch((error) => {
        this.setState({
          imageUploadMessage:
            'An error occurred while executing the query. Please try Again'
        });
      })
      .then(() => {
        console.log('Image uploaded');
      });
  };
  onSubmit = (event) => {
    event.preventDefault();
    // Update SubCategoryDetail
    this.props.addSubCategory(this.state.subCategory);
    setTimeout(() => {
      this.props.history.push(
        `/vendor/sub-category/${this.state.subCategory.superCategoryId}/${this.state.subCategory.categoryId}`
      );
    }, 3000);
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        <CardHeader color="primary">
          <h4 className={classes.cardTitleWhite}>Add a SubCategory</h4>
          <p className={classes.cardCategoryWhite}>
            When choosing icon, PNG images would be better over JPG or imap
          </p>
        </CardHeader>
        <CardBody>
          <br />
          <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
              <CustomInput
                labelText="Sub category Name"
                value={this.state.subCategory.name}
                onChange={this.onChange}
                name="name"
                id="name"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </GridItem>

            <GridItem xs={12} sm={12} md={4}>
              <CustomInput
                labelText="SubCategory Icon"
                id="icon"
                type="file"
                name="icon"
                accept="image/png, image/jpeg, image/jpg"
                onChange={this.onUpload}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <select
                fullWidth={true}
                required="required"
                name="superCategoryId"
                id="inputState"
                className="form-control"
                value={this.state.subCategory.superCategoryId}
                onChange={this.onChangeSelect}
                style={{ marginTop: '2.5em' }}
              >
                {this.props.superCategories.length > 0 ? (
                  this.props.superCategories
                    .filter(
                      (categorieFilter) =>
                        categorieFilter.id ===
                        this.state.subCategory.superCategoryId
                    )
                    .map((type) => (
                      <option value={type.id} key={type.id}>
                        {type.name}
                      </option>
                    ))
                ) : (
                  <option disabled="disabled" selected="selected">
                    Select Super-Category
                  </option>
                )}
              </select>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <select
                fullWidth={true}
                required="required"
                name="categoryId"
                id="inputState"
                className="form-control"
                value={this.state.subCategory.categoryId}
                onChange={this.onChangeSelect}
                style={{ marginTop: '2.5em' }}
              >
                {this.props.categories.length > 0 ? (
                  this.props.categories
                    .filter(
                      (categorieFilter) =>
                        categorieFilter.id === this.state.subCategory.categoryId
                    )
                    .map((type) => (
                      <option value={type.id} key={type.id}>
                        {type.name}
                      </option>
                    ))
                ) : (
                  <option disabled="disabled" selected="selected">
                    Select Category
                  </option>
                )}
              </select>
            </GridItem>
            <br />
            <p style={{ color: '#000' }}>{this.state.imageUploadMessage}</p>
          </GridContainer>
        </CardBody>
        <CardFooter>
          <Button
            type="submit"
            onClick={this.onSubmit}
            style={{
              color: '#fff',
              backgroundColor: '#9c27b0',
              boxShadow:
                '0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)'
            }}
          >
            Add Category
          </Button>
        </CardFooter>
        <br /> <br />
        <Table hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Icon</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>1</th>
              <td>{this.state.subCategory.name}</td>
              <td>
                <img
                  src={this.state.subCategory.icon}
                  style={{ height: '70px' }}
                  alt=""
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </>
    );
  }
}

const mapStateWithProps = (state) => ({
  superCategories: state.vendor.superCategories,
  categories: state.vendor.categories
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: () => dispatch(getCategoryList()),
    getAllCategoryList: (superCategoryId) =>
      dispatch(getAllCategoryList(superCategoryId)),
    addSubCategory: (categoryData) => dispatch(addSubCategory(categoryData)),
    upload: (data) => dispatch(upload(data))
  };
};

export default compose(
  connect(mapStateWithProps, mapDispatchWithProps),
  withStyles(styles)
)(AddSubCategory);
